import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Account } from "@faire/web/slate/icons/foundation/Account";
import React from "react";
import { OTHER_NODES_LABEL } from "../../shared/other-node";
import { AccountEmailIA } from "../instantAnswers/myAccount-accountEmail";
import { ApplyForEoriIA } from "../instantAnswers/myAccount-applyForEori";
import { CheckAccountVerificationStatusIA } from "../instantAnswers/myAccount-checkAccountVerificationStatus";
import { ContactInfoIA } from "../instantAnswers/myAccount-contactInfo";
import { DoNotHaveRequestedInfoIA } from "../instantAnswers/myAccount-doNotHaveReuqestedInfo";
import { EmailNotificationsIA } from "../instantAnswers/myAccount-emailNotifications";
import { LinkingPosIA } from "../instantAnswers/myAccount-linkingPos";
import { ManageEoriInfoIA } from "../instantAnswers/myAccount-manageEoriInfo";
import { ManageTeamsIA } from "../instantAnswers/myAccount-manageTeams";
import { MultifactorAuthIA } from "../instantAnswers/myAccount-multifactorAuth";
import { PasswordIA } from "../instantAnswers/myAccount-password";
import { PasswordResetIA } from "../instantAnswers/myAccount-passwordReset";
import { ProvideRequestedInfoIA } from "../instantAnswers/myAccount-provideRequestedInfo";
import { ShippingAddressIA } from "../instantAnswers/myAccount-shippingAddress";
import { TroubleshootingAndOtherPOSIA } from "../instantAnswers/myAccount-troubleshootingAndOtherPos";
import { UnlinkingPosIA } from "../instantAnswers/myAccount-unlinkingPos";
import { UpdateAccountTypeIA } from "../instantAnswers/myAccount-updateAccountType";
import { VatAndTaxIdentifiersIA } from "../instantAnswers/myAccount-vatAndTaxIdentifiers";
import { WhatIsEoriIA } from "../instantAnswers/myAccount-whatIsEori";
import { WhyOrderCancelledIA } from "../instantAnswers/myAccount-whyOrderCancelled";
import { WhyOrderOnHoldIA } from "../instantAnswers/myAccount-whyOrderOnHold";
import { BillingAddressIA } from "../instantAnswers/shared-billingAddress";
import { AccountVerificationPendingVisibilityFn } from "../visibilityFunctions/accountVerificationPendingVisibilityFn";
import { AccountVerificationRejectedVisibilityFn } from "../visibilityFunctions/accountVerificationRejectedVisibilityFn";
import { AccountVerificationVisibilityFn } from "../visibilityFunctions/accountVerificationVisibilityFn";
import { ManageEoriInfoVisibilityFn } from "../visibilityFunctions/manageEoriInfoVisibilityFn";
import { VatAndTaxIdentifiersVisibilityFn } from "../visibilityFunctions/vatAndTaxIdentifiersVisibilityFn";
export var useMyAccountRetailerNodes = function useMyAccountRetailerNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = useArticles();
  return {
    MyAccount: {
      id: "MyAccount",
      label: strictLocalize({
        id: "uB52R5",
        defaultMessage: "My account"
      }),
      icon: /*#__PURE__*/React.createElement(Account, {
        fontSize: "24px",
        color: "faireBlack"
      }),
      children: ["AccountVerification", "ManageAccount", "AccountSettings", "PointOfSale"],
      level: 1,
      sidebarTitle: strictLocalize({
        id: "KCsrJG",
        defaultMessage: "Account issue"
      })
    },
    AccountVerification: {
      id: "AccountVerification",
      label: strictLocalize({
        id: "2FcvDg",
        defaultMessage: "Account verification"
      }),
      children: ["WhyOrderOnHold", "ProvideRequestedInformation", "DoNotHaveRequestedInformation", "CheckAccountVerificationStatus", "WhyOrderCancelled", "OtherAccountVerification"],
      isNodeVisible: AccountVerificationVisibilityFn,
      level: 2
    },
    ManageAccount: {
      id: "ManageAccount",
      label: strictLocalize({
        id: "84Wa06",
        defaultMessage: "Manage account"
      }),
      children: ["AccountEmail", "ManageTeams", "EmailNotifications"],
      level: 2
    },
    AccountSettings: {
      id: "AccountSettings",
      label: strictLocalize({
        id: "uaosyt",
        defaultMessage: "Account settings"
      }),
      children: ["PasswordReset", "MultifactorAuth", "UpdateAccount", "OtherAccountSettings"],
      level: 2
    },
    PointOfSale: {
      id: "PointOfSale",
      label: strictLocalize({
        id: "YW1YgA",
        defaultMessage: "Point of sale"
      }),
      children: ["LinkingPOS", "Troubleshooting", "UnlinkingPOS", "OtherPointOfSale"],
      level: 2
    },
    WhyOrderOnHold: {
      id: "WhyOrderOnHold",
      label: strictLocalize({
        id: "Io1gMg",
        defaultMessage: "Why is my order on hold"
      }),
      articles: [articles.MyOrders.BUSINESS_PROFILE],
      instantAnswer: WhyOrderOnHoldIA(strictLocalize, articles),
      isNodeVisible: AccountVerificationPendingVisibilityFn,
      level: 3
    },
    ProvideRequestedInformation: {
      id: "ProvideRequestedInformation",
      label: strictLocalize({
        id: "PybJ+h",
        defaultMessage: "Provide requested information"
      }),
      articles: [articles.Account.ORDER_ISSUE],
      instantAnswer: ProvideRequestedInfoIA(strictLocalize),
      isNodeVisible: AccountVerificationPendingVisibilityFn,
      level: 3
    },
    DoNotHaveRequestedInformation: {
      id: "DoNotHaveRequestedInformation",
      label: strictLocalize({
        id: "FU93LZ",
        defaultMessage: "Do not have requested information"
      }),
      articles: [articles.Account.NOT_OPEN],
      instantAnswer: DoNotHaveRequestedInfoIA(strictLocalize, articles),
      isNodeVisible: AccountVerificationPendingVisibilityFn,
      level: 3
    },
    CheckAccountVerificationStatus: {
      id: "CheckAccountVerificationStatus",
      label: strictLocalize({
        id: "IshNgf",
        defaultMessage: "Check account verification status"
      }),
      articles: [articles.MyOrders.BUSINESS_PROFILE],
      instantAnswer: CheckAccountVerificationStatusIA(strictLocalize, articles),
      isNodeVisible: AccountVerificationPendingVisibilityFn,
      level: 3
    },
    WhyOrderCancelled: {
      id: "WhyOrderCancelled",
      label: strictLocalize({
        id: "3zAjuD",
        defaultMessage: "Why is my order cancelled"
      }),
      instantAnswer: WhyOrderCancelledIA(strictLocalize, articles),
      isNodeVisible: AccountVerificationRejectedVisibilityFn,
      level: 3
    },
    OtherAccountVerification: {
      id: "OtherAccountVerification",
      label: OTHER_NODES_LABEL(strictLocalize),
      articles: [articles.MyOrders.BUSINESS_PROFILE],
      isNodeVisible: AccountVerificationPendingVisibilityFn,
      level: 3
    },
    AccountEmail: {
      id: "AccountEmail",
      label: strictLocalize({
        id: "qzkDIg",
        defaultMessage: "Account email"
      }),
      articles: [articles.Account.ACCOUNT_EMAIL],
      instantAnswer: AccountEmailIA(strictLocalize),
      level: 3
    },
    ManageTeams: {
      id: "ManageTeams",
      label: strictLocalize({
        id: "WNGeTn",
        defaultMessage: "Manage teams"
      }),
      articles: [articles.Account.MANAGE_TEAMS],
      instantAnswer: ManageTeamsIA(strictLocalize),
      level: 3
    },
    EmailNotifications: {
      id: "EmailNotifications",
      label: strictLocalize({
        id: "xdH/UZ",
        defaultMessage: "Email notifications"
      }),
      articles: [articles.Account.EMAIL_NOTIFICATIONS],
      instantAnswer: EmailNotificationsIA(strictLocalize),
      level: 3
    },
    PasswordReset: {
      id: "PasswordReset",
      label: strictLocalize({
        id: "JBijqh",
        defaultMessage: "Password reset"
      }),
      articles: [articles.FAQ.RESETTING_PASSWORD],
      instantAnswer: PasswordResetIA(strictLocalize),
      level: 3
    },
    MultifactorAuth: {
      id: "MultifactorAuth",
      label: strictLocalize({
        id: "k8NE3+",
        defaultMessage: "Multifactor authentication"
      }),
      instantAnswer: MultifactorAuthIA(strictLocalize),
      level: 3
    },
    UpdateAccount: {
      id: "UpdateAccount",
      label: strictLocalize({
        id: "FzuD23",
        defaultMessage: "Update account"
      }),
      children: ["BillingAddress", "ShippingAddress", "ContactInfo", "EORI", "Password", "VATAndTaxIdentifiers", "UpdateAccountType"],
      level: 3
    },
    OtherAccountSettings: {
      id: "OtherAccountSettings",
      label: OTHER_NODES_LABEL(strictLocalize),
      articles: [articles.GettingStarted.RESELLER_ID, articles.GettingStarted.BRICK_AND_MORTAR, articles.MyOrders.BUSINESS_PROFILE],
      level: 3
    },
    LinkingPOS: {
      id: "LinkingPOS",
      label: strictLocalize({
        id: "kiznxY",
        defaultMessage: "Linking POS"
      }),
      articles: [articles.MyOrders.SYNC_SQUARE_POS],
      instantAnswer: LinkingPosIA(strictLocalize),
      level: 3
    },
    Troubleshooting: {
      id: "Troubleshooting",
      label: strictLocalize({
        id: "LjdkiP",
        defaultMessage: "Troubleshooting"
      }),
      articles: [articles.MyOrders.SYNC_SQUARE_POS],
      instantAnswer: TroubleshootingAndOtherPOSIA(strictLocalize),
      level: 3
    },
    UnlinkingPOS: {
      id: "UnlinkingPOS",
      label: strictLocalize({
        id: "zvk6PX",
        defaultMessage: "Unlinking POS"
      }),
      articles: [articles.MyOrders.SYNC_SQUARE_POS],
      instantAnswer: UnlinkingPosIA(strictLocalize),
      level: 3
    },
    OtherPointOfSale: {
      id: "OtherPointOfSale",
      label: OTHER_NODES_LABEL(strictLocalize),
      articles: [articles.MyOrders.SYNC_SQUARE_POS],
      instantAnswer: TroubleshootingAndOtherPOSIA(strictLocalize),
      level: 3
    },
    BillingAddress: {
      id: "BillingAddress",
      label: strictLocalize({
        id: "z5ti4q",
        defaultMessage: "Billing address"
      }),
      articles: [articles.PaymentsAndInvoices.HOW_DO_I_CHANGE_MY_BILLING_ADDRESS],
      instantAnswer: BillingAddressIA(strictLocalize),
      level: 4
    },
    ShippingAddress: {
      id: "ShippingAddress",
      label: strictLocalize({
        id: "EPdy0V",
        defaultMessage: "Shipping address"
      }),
      articles: [articles.FulfillingOrders.SHIPPING_ADDRESS],
      instantAnswer: ShippingAddressIA(strictLocalize),
      level: 4
    },
    ContactInfo: {
      id: "ContactInfo",
      label: strictLocalize({
        id: "jkqM2m",
        defaultMessage: "Contact information"
      }),
      instantAnswer: ContactInfoIA(strictLocalize),
      level: 4
    },
    EORI: {
      id: "EORI",
      label: strictLocalize({
        id: "XT/NsZ",
        defaultMessage: "EORI"
      }),
      children: ["WhatIsEORI", "ApplyForEORI", "ManageEORI"],
      level: 4
    },
    Password: {
      id: "Password",
      label: strictLocalize({
        id: "5QVTHl",
        defaultMessage: "Password"
      }),
      instantAnswer: PasswordIA(strictLocalize),
      level: 4
    },
    VATAndTaxIdentifiers: {
      id: "VATAndTaxIdentifiers",
      label: strictLocalize({
        id: "b6O3ej",
        defaultMessage: "VAT and tax identifiers"
      }),
      articles: [articles.ImportFeesAndDuties.VAT],
      instantAnswer: VatAndTaxIdentifiersIA(strictLocalize),
      isNodeVisible: VatAndTaxIdentifiersVisibilityFn,
      level: 4
    },
    UpdateAccountType: {
      id: "UpdateAccountType",
      label: strictLocalize({
        id: "X8j4jF",
        defaultMessage: 'Update account type to "Brick and mortar"'
      }),
      instantAnswer: UpdateAccountTypeIA(strictLocalize),
      level: 4
    },
    WhatIsEORI: {
      id: "WhatIsEORI",
      label: strictLocalize({
        id: "MxJaAT",
        defaultMessage: "What is EORI number"
      }),
      articles: [articles.ImportFeesAndDuties.EORI],
      instantAnswer: WhatIsEoriIA(strictLocalize),
      level: 5
    },
    ApplyForEORI: {
      id: "ApplyForEORI",
      label: strictLocalize({
        id: "rOQFiK",
        defaultMessage: "Apply for EORI number"
      }),
      instantAnswer: ApplyForEoriIA(strictLocalize, articles),
      isNodeVisible: ManageEoriInfoVisibilityFn,
      level: 5
    },
    ManageEORI: {
      id: "ManageEORI",
      label: strictLocalize({
        id: "+B5d5l",
        defaultMessage: "Manage EORI information"
      }),
      instantAnswer: ManageEoriInfoIA(strictLocalize),
      isNodeVisible: ManageEoriInfoVisibilityFn,
      level: 5
    }
  };
};